module.exports = __webpack_public_path__ + "static/media/logoBlack.cfd40db0.svg";